import { Component, Input } from '@angular/core';
import { AppConstants } from 'src/app/app-constants';
import { DeviceSettingsService } from '../../library/device-settings.service';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { AmplitudeTrackingEventPropValues } from 'src/app/utils/enums/amplitude/amplitudeTrackingEventPropValues.enum';
import { ControlService } from '../../library/control.service';
import { PlayerService } from '../../library/player.service';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { CallStoreService } from '../../library/call-store/call-store.service';

@Component({
  selector: 'app-device-settings-call',
  templateUrl: './device-settings-call.component.html',
  styleUrls: ['./device-settings-call.component.scss'],
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'settings',
    },
  ],
})
export class DeviceSettingsCallComponent {
  @Input() deviceSettingsService: DeviceSettingsService | undefined;
  @Input() controlService: ControlService | undefined;
  @Input() playerService: PlayerService | undefined;

  isDiagnosticRunning: boolean = false;

  constructor(
    private amplitudeService: AmplitudeService,
    private translationService: TranslationService,
    public callStore: CallStoreService
  ) {}

  ngOnInit(): void {
    this.translationService.loadScopedTranslation('settings');
  }

  onDiagnosticRunningChange(isRunning: boolean): void {
    this.isDiagnosticRunning = isRunning;
  }

  public sendAmplitudeBeginCallEvent(): void {
    // Sending the Event of Clicking on FTU Begin Call
    this.amplitudeService.trackEvent(
      AmplitudeTrackingEvents.FTU_DEVICE_SETTINGS_CLICK_START_CALL,
      {
        camera_status: this.controlService?.isVideoOn
          ? AmplitudeTrackingEventPropValues.CAMERA_STATUS_CAMERA_ON
          : AmplitudeTrackingEventPropValues.CAMERA_STATUS_CAMERA_OFF,
      }
    );
  }

  public handleStartCallClick(): void {
    this.sendAmplitudeBeginCallEvent();
    this.deviceSettingsService?.joinCall();
  }

  get isAudioOnly() {
    const isCertificationGuidedCall =
      this.callStore.getModuleAssignmentType() === AppConstants.TYPE_CERTIFICATION &&
      this.callStore.getCallType() === AppConstants.CALL_TYPE_GUIDED;
    if (isCertificationGuidedCall) {
      return false;
    }
    return (
      this.deviceSettingsService?.audioDeviceSelected &&
      !this.deviceSettingsService?.videoDeviceSelected
    );
  }
}
